<template>
	<div class="prazo-datas">
		<section class="flex flex-col w-full">
			<h4 class="subtitle mt-10 mb-4 font-bold">Datas</h4>

				<div class="flex flex-wrap w-full">
					<vs-input
						:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
						name="dt_inicio"
						class="input-dt-inicio w-2/5 mb-4 mr-4"
						label="Data de início do prazo"
						v-model="dateInicioObj"
						@input.native="(event) => {
							handlerFormatInputData(event);
							getDataFim();
						}"
					></vs-input>

					<vs-input
						:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
						class="input-quantidade-dias flex-1 mb-4 mr-4"
						type="number"
						name="qtd_dias"
						label="Quant. de dias"
						v-model="quantidadeDiasObj"
						@input.native="getDataFim"
					></vs-input>

					<div class="mb-4">
						<label class="vs-input--label">Tipo de dias</label>
						<div class="btn-group">
							<vs-button
								:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
								size="small"
								type="border"

								class="button-tipo-dias"
								:class="{
									active: tipoCalculoObj == 'false'
								}"
								@click="tipoCalculoObj = 'false'"
								>Corridos</vs-button
							>
							<vs-button
								:disabled="disabled || prazoDesativado || prazoFinalizado || prazoPerdido"
								size="small"
								type="border"

								class="button-tipo-dias"
								:class="{
									active: tipoCalculoObj == 'true'
								}"
								@click="tipoCalculoObj = 'true'"
								>Úteis</vs-button
							>
						</div>
						<input type="hidden" name="dias_uteis" v-model="tipoCalculoObj">
					</div>
				</div>

				<div class="relative flex">
					<vs-input
						disabled
						name="dt_fim"
						class="w-2/4 mb-4 mr-4"
						label="Data de fim do prazo"
						v-model="dateFimObj"
						@input.native="(event) => {
							handlerFormatInputData(event);
							getDataFim();
						}"
					></vs-input>
					<div>
						<vs-loader-spinner v-show="isLoadingDataFim" class="loading-data-final" />
					</div>
				</div>
		</section>
	</div>
</template>

<script>

import { ptBR } from "vuejs-datepicker/src/locale";
import DateHelper from '../../../../../../helpers/DateHelper';
import ErrorHelper from '../../../../../../helpers/ErrorHelper';
import EncryptHelper from "../../../../../../helpers/EncryptHelper";
import Prazo from '../../../../../../models/Prazo';

import VsLoaderSpinner from '../../../../../../components/loaders/vs-loader-spinner/VsLoaderSpinner';


export default {
	data() {
		return {
			pt: ptBR,
			timeoutGetDataFim: null,
			isLoadingDataFim: false,
			identificationKey: null,
		}
	},
	components: {
		VsLoaderSpinner
	},
	props: {
		dateInicio: {
			required: true,
		},
		dateFim: {
			required: true,
		},
		quantidadeDias: {
			required: true,
		},
		tipoCalculo: {
			required: true,
		},
		edicao: {
			default: false,
			type: Boolean
		},
		prazoDesativado: {
			required: true
		},
		prazoFinalizado: {
			required: true
		},
		prazoPerdido: {
			required: true
		},
	},
	computed: {
		disabled() {
			return ((!this.$permissions.can('prazomodificar') && this.edicao) || (!this.$permissions.can('prazoadicionar') && !this.edicao)) && !this.$permissions.can('autenticadosuperuser');
		},
		disabledDates() {
			const date = new Date();
			date.setDate(new Date().getDate() - 1); // Disable all dates up to specific date

			return {
				to: date
			};
		},
		dateInicioObj: {
			set(value) {
				this.$emit("update:dateInicio", value);
			},
			get() {
				return this.dateInicio;
			}
		},
		dateFimObj: {
			set(value) {
				this.$emit("update:dateFim", value);
			},
			get() {
				return this.dateFim;
			}
		},
		quantidadeDiasObj: {
			set(value) {
				this.$emit("update:quantidadeDias", value);
			},
			get() {
				return this.quantidadeDias;
			}
		},
		tipoCalculoObj: {
			set(value) {
				this.$emit("update:tipoCalculo", value);
			},
			get() {
				return this.tipoCalculo;
			}
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
	},
	methods: {
		handlerFormatInputData(event) {
			DateHelper.dateMask(event);
		},
		async getDataFim() {
			try {

				this.isLoadingDataFim = true;
				const identificationKey = EncryptHelper.encrypt("key");
				this.identificationKey = identificationKey;

				if (this.timeoutGetDataFim) {
					clearTimeout(this.timeoutGetDataFim);
				}

				this.timeoutGetDataFim = setTimeout(async () => {
					try {
						if (this.dateInicio && this.dateInicio.length == 10 && this.quantidadeDias) {
							const data = {
								dt_inicio: DateHelper.convertDate(
									this.dateInicio,
									"DD/MM/YYYY",
									"YYYY-MM-DD"
								),
								qtd_dias: this.quantidadeDias,
							};

						if (data.dt_inicio == this.dateInicio) {
							throw Prazo.errorDataInicioInvalida();
						}

						if (this.tipoCalculoObj) {
							data["dias_uteis"] = this.tipoCalculoObj == "true";
						}

						this.dateFimObj = null;

						const { dt_fim, dt_inicio, qtd_dias, dias_uteis } = await Prazo.getDataFim(this.empresaPk, data);

						// Validar se a data final não é passada APÓS calcular a data de fim
						const hoje = new Date();
						hoje.setHours(0, 0, 0, 0); // Zera as horas para comparar apenas a data
						
						// Converter string YYYY-MM-DD para Date
						const dataFimDate = new Date(dt_fim + "T12:00:00"); // Meio dia para evitar problemas de timezone
						dataFimDate.setHours(0, 0, 0, 0);
						
						// Permite data de hoje (>= hoje)
						if (dataFimDate < hoje) {
							// Lança o erro para ser capturado no catch
							throw Prazo.errorDataPassada();
						}

						const tipoCalculo = this.tipoCalculo == "true";
						const dataInicio = DateHelper.convertDate(
							this.dateInicio,
							"DD/MM/YYYY",
							"YYYY-MM-DD"
						);

						if (dt_inicio == dataInicio && qtd_dias == this.quantidadeDias && (!this.tipoCalculo || dias_uteis == tipoCalculo)) {
							if (this.identificationKey == identificationKey) {
								this.dateFimObj = DateHelper.convertDate(
									dt_fim,
									"YYYY-MM-DD",
									"DD/MM/YYYY"
								);
							}
						}

						} else {
							this.dateFimObj = null;
						}

					this.isLoadingDataFim = false;
				} catch (error) {
					// Exibir toast de erro
					if (error && error.fields_errors) {
						const errorMessage = error.fields_errors[0].errors[0].message;
						this.$vs.notify({
							title: "Erro na data",
							text: errorMessage,
							color: 'danger',
							icon: 'error',
							time: 5000
						});
					}
					
					// Tentar ErrorHelper padrão
					if (this.edicao) {
						ErrorHelper.renderFormError("#form-editar-prazo", error);
					} else {
						ErrorHelper.renderFormError("#form-adicionar-prazo", error);
					}
					
					this.isLoadingDataFim = false;
				}
				}, 1000);


		} catch (error) {
			this.isLoadingDataFim = false;
		}
		}
	},
	watch: {
		tipoCalculo() {
			this.getDataFim();
		}
	}
}
</script>

<style lang="scss" scoped src="./datas.scss"></style>
